import {Button, Flex, Popconfirm, Table, TableColumnsType, Tag} from 'antd';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Loader from '../../../../../components/Loader/Loader';
import MainTableTitle from '../../../../../components/Table/Utils/MainTableTitle';
import {allRoutes} from '../../../../../constants/Routes';
import {APITypeEnum} from '../../../../../services/interface/tableAPIType';
import addRole from '../../../../../services/modules/UserManager/addRole';
import {ColumnDataType} from '../Constants/ColumnDataType';

const RoleManager: React.FC = () => {
  const [dataSource, setDataSource] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // const userPer = useUserStore.getState().userPermission;

  const navigate = useNavigate();

  const columns: TableColumnsType<ColumnDataType> = [
    {
      title: 'Role List',
      dataIndex: 'title',
      key: '_id',
      render: (value: any) => {
        return <div>{`${value}`}</div>;
      }
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      render: (value: any) => {
        return (
          <Tag color={value === true ? 'green' : 'red'}>
            {value === true ? 'Active' : 'Inactive'}
          </Tag>
        );
      },
      key: '_id'
    },
    {
      title: 'Action',
      dataIndex: 'action',
      width: '20%',
      render: (value: any, record: any) => {
        return (
          <>
            <Button
              type="link"
              onClick={() => {
                handleEditClick(record);
              }}
            >
              Edit
            </Button>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => {
                handleDelete(record);
              }}
            >
              <Button type="link" style={{marginRight: '20px'}}>
                Delete
              </Button>
            </Popconfirm>
          </>
        );
      },
      key: '_id'
    }
  ];

  const handleClick = () => {
    navigate(allRoutes.setting.addRole);
  };

  const handleDelete = (recordDeleteId: any) => {
    addRole(APITypeEnum.METHOD_DELETE, undefined, `${recordDeleteId._id}`)
      .then(() => {
        setRefresh(!refresh);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  useEffect(() => {
    addRole(APITypeEnum.GET_ALL, true)
      .then((data: any) => {
        setDataSource(data ?? []);
      })
      .catch(() => {
        setDataSource([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [refresh]);

  const handleEditClick = (recordEditId: any) => {
    navigate(allRoutes.setting.updateRole, {state: recordEditId});
  };

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Flex className="usermFlex">
        <MainTableTitle title="Roles" />
        <Flex className="content" align="center" justify="center">
          <Button
            className="buttonAddUser"
            type="primary"
            onClick={handleClick}
          >
            Add New Role
          </Button>
          <Table
            columns={columns}
            dataSource={dataSource}
            className="table"
            rowKey="_id"
          />
        </Flex>
      </Flex>
    </>
  );
};

export default RoleManager;
